import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedRewardAppPreviewComponent } from './reward-app-preview.component';

@NgModule({
  imports: [CommonModule],
  declarations: [SharedRewardAppPreviewComponent],
  exports: [SharedRewardAppPreviewComponent]
})
export class SharedRewardAppPreviewModule {}
